import React from 'react';
import { Page, Text, View, Document } from '@react-pdf/renderer';
import { Table, DataTableCell, TableHeader, TableBody, TableCell } from '@david.kucsai/react-pdf-table'
import Header from '../informes/Header';
import Footer from '../informes/Footer';
import InformacionDelPaciente from '../informes/InformacionDelPaciente';
import moment from 'moment';
import stylesReport from '../informes/styles';
import { getValueField } from '../../utils/common'
import FirmaEspecialista from '../informes/FirmaEspecialista';
import WaterMark from '../informes/WaterMark';

const FONT_SIZE = 8;

const ReportBRNM = ({ estudio, paciente, qrValue }) => {

  const {
    pageStyle,
    dataContainerStyle,
    blueTextStyle,
    textStyle,
    mainContainerStyle,
    dataTextStyle,
    dividerStyle,
    longTextStyle
  } = stylesReport;

  return (
      <Page size="LETTER" wrap={true} style={[pageStyle, {paddingBottom: 100}]}>
        <Header />
        <WaterMark typePage="LETTER" />
        <InformacionDelPaciente
          paciente={paciente}
          fechaSolicitud={moment(estudio.fechaSolicitud).utc().format("DD/MM/YYYY")}
          fechaReporte={moment(estudio.fechaReporte).utc().format("DD/MM/YYYY")}
          codigoEstudio={`${estudio.codigoEstudio}${estudio.estudioNumero}`}
          ordenNo={estudio.ordenNo}
          medico={estudio.ordenID.nombreMedico}
          spaceMedico
        />
        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={dataContainerStyle}>
            <Text style={blueTextStyle}> {estudio.areaDeEstudioID.nombre}</Text>
          </View>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 2 }}>
              <Text style={textStyle}>Estudio:
                <Text style={dataTextStyle}>{` ${estudio.estudioID.description} `}</Text>
              </Text>
              <Text style={textStyle}>Indicación:
                <Text style={dataTextStyle}>{` ${getValueField(estudio.camposEstudio, 'indicacion')} `}</Text>
              </Text>
              <Text style={textStyle}>Tipo de Muestra:
                <Text style={dataTextStyle}>{` ${estudio.tipoDeMuestraID.nombre} `}</Text>
              </Text>
            </View>
          </View>
          <View style={dividerStyle}></View>
        </View>

        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <Text style={textStyle}>Resultado:
                <Text style={dataTextStyle}> {getValueField(estudio.camposEstudio, 'resultado')}</Text>
              </Text>
            </View>
          </View>
        </View>

        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <Text style={textStyle}>Interpretación:
                {
                  getValueField(estudio.camposEstudio, 'interpretacion') !== "" ?
                    <Text style={[textStyle, dataTextStyle]}> {getValueField(estudio.camposEstudio, 'interpretacion')}</Text> : null
                }
              </Text>
            </View>
          </View>
        </View>

        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <Text style={textStyle}>Notas:</Text>
              <Text style={longTextStyle}> -El resultado de este estudio deberá ser siempre interpretado en el contexto de datos clínicos y familiares. </Text>
              <Text style={longTextStyle}> -Puede ser beneficioso para esta persona y sus familiares un asesoramiento genético-clínico para discutir las implicancias directas e indirectas de éste resultado.</Text>
              <Text style={longTextStyle}> -Las variantes de significado incierto se reportan en observaciones. En caso de variantes inciertas, intrónicas o sinónimas sin predictores bioinformáticos que sugieran afectación del splicing del ARNm, y las evidencias no sean suficientes para clasificarlas como probablemente benignas, serán reportadas en tabla anexa al informe.</Text>
            </View>
          </View>
        </View>

        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <Text style={textStyle}> Cáncer de mama y ovario hereditario asociado a genes BRCA1 y BRCA2</Text>
              <Text style={longTextStyle}> El síndrome de cáncer de mama y ovario hereditario asociado a los genes BRCA1 y BRCA2 (HBOC) se caracteriza por un mayor riesgo de cáncer de mama femenino y masculino, cáncer de ovario (incluye cáncer de las trompas de Falopio y del peritoneal primario) y, en menor medida, otros como cáncer de próstata, cáncer de páncreas y melanoma, principalmente en individuos con una variante patogénica en el gen BRCA2. Los riesgos exactos de contraer cáncer difieren ligeramente dependiendo de si el HBOC es causado por una variante patogénica en BRCA1 o BRCA2. </Text>
              <Text style={longTextStyle}> Una vez que se ha identificado una variante patogénica en la línea germinal BRCA1 o BRCA2 que predispone al cáncer en una familia, es posible identificar a aquellos miembros de la familia que también portan la variante patogénica familiar, y, por lo tanto, necesitan una mayor vigilancia e intervención temprana cuando se identifica un cáncer. Las variantes patogénicas en la línea germinal en BRCA1 y BRCA2 se heredan de manera autosómica dominante. La gran mayoría de los individuos con una variante patogénica en BRCA1 o BRCA2 la han heredado de uno de sus padres. Sin embargo, debido a la penetrancia incompleta, puede variar la edad del desarrollo del cáncer, la reducción del riesgo de cáncer resultante de la cirugía profiláctica o la muerte prematura; no todas las personas con una variante patogénica en BRCA1 o BRCA2 tienen un progenitor afectado con cáncer.</Text>
              <Text style={longTextStyle}> Los familiares de primer grado de un individuo con una variante patogénica en la línea germinal BRCA1 o BRCA2 tienen una probabilidad del 50% de ser portadores. La descendencia de un individuo portador tiene un 50% de probabilidad de heredar la variante. Para estos casos se sugiere seguimiento y evaluación en el contexto clínico/familiar. Las pruebas prenatales son posibles para embarazos con mayor riesgo si se conoce la variante familiar que predispone al cáncer; sin embargo, las solicitudes de diagnóstico prenatal de enfermedades de aparición en adultos son poco frecuentes y requieren un asesoramiento genético cuidadoso.</Text>
              <Text style={longTextStyle}>Para más información: https://www.ncbi.nlm.nih.gov/books/NBK1247/</Text>
            </View>
          </View>
        </View>

        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <Text style={textStyle}> Metodología NGS:</Text>
              <Text style={longTextStyle}> -Extracción y purificación del ADN genómico a partir de la muestra remitida utilizando DNeasy® Blood & Tissue Kit de Qiagen®. Amplificación de las regiones de interés mediante un Community Panel para BRCA1 y BRCA2 constituido por un pool de primers con tecnología AmpliseqTM diseñado y validado por expertos en el área para amplificar los exones y bordes exón-intrón de los genes BRCA1 y BRCA2. La utilización de este pool de primers permite amplificar un 100% de la secuencia codificante de los genes BRCA1 y BRCA2 y regiones intrónicas flanqueantes. Secuenciación de las regiones amplificadas mediante Post-LightTM Ion Semicondutor Sequencing (Next Generation Sequencing), en la plataforma Ion Torrent Machine ® System/ Ion S5 System. La cobertura mínima admitida es de 30X por amplicón secuenciado. Identificación de variantes con respecto al genoma humano de referencia hg19 (Assembly GRCh37) utilizando el software Variant Caller de Ion Torrent y software SophiaGenetics. Se utiliza el Software IonReporter para anotar las variantes encontradas y para el filtrado de estas. Búsqueda de las variantes detectadas en bases de datos internacionales, entre ellas ClinVar, LOVD 3.0, UMD y bibliografía disponible para determinar su significancia clínica. Las variantes se clasifican de acuerdo con las guías del Colegio Americano de Genética Médica y Genómica (ACMG). Las categorías de clasificación son: patogénicas, probablemente patogénicas, variantes de significado incierto, variantes probablemente benignas y benignas. Se reportan en el informe únicamente variantes patogénicas o probablemente patogénicas. Variantes probablemente benignas y benignas serán reportadas en tabla anexa al informe sólo en caso de que sean exónicas o intrónicas cercanas al exón (distancia menor o igual a 13 pares de bases). Sobre las regiones amplificadas el análisis permite detectar los cambios nucleotídicos simples, así como INS/DEL de hasta aproximadamente 15 pb. Confirmación por secuenciación Sanger en caso de encontrarse una variante patogénica. </Text>
            </View>
          </View>
        </View>

        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <Text style={textStyle}> Metodología MLPA:</Text>
              <Text style={longTextStyle}> Multiplex Ligation-dependent Probe Amplification (MLPA) utilizando los kits: P002 para BRCA1 y P045 para BRCA2/CHEK2 de MRC-Holland®. Análisis por secuenciador automático de los fragmentos obtenidos. Estudio de los rearreglos genomicos, duplicaciones y deleciones, en las regiones 5 ́UTR y codificante del gen BRCA1 y todos los exones de BRCA2. El análisis se realiza empleando el software Coffalyser (información de este en Coffalyser.Net). En el mismo ensayo es posible evaluar la presencia de la variante 1100delC del gen CHEK2. </Text>
              <Text style={[longTextStyle, {marginTop: 5}]}>Transcriptos de referencia: NM_007294.3(BRCA1) y NM_000059.3(BRCA2)</Text>
              <Text style={[longTextStyle, {marginTop: 5}]}>En caso de detectarse una variante patogénica/probablemente patogénica por NGS, no se realizará análisis de grandes rearreglos.</Text>
              <Text style={[longTextStyle, {marginTop: 5}]}>El porcentaje de variantes detectadas utilizando las dos técnicas es mayor al 98%.</Text>

            </View>
          </View>
        </View>

        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <Text style={textStyle}> Limitaciones técnicas:</Text>
              <Text style={longTextStyle}> Diferentes situaciones pueden resultar en errores en la detección de variantes genéticas, entre ellas: muestras contaminadas previo al arribo a nuestro laboratorio, presencia de mosaicismos, presencia de variantes genéticas que producen "allelic drop-outs", estudios realizados sobre ADN extraído a partir de tejidos incluidos en parafina, presencia de pseudogenes (regiones con homología), identificación incorrecta de variantes en zonas de homopolímeros o con alto contenido de GC.</Text>
            </View>
          </View>
        </View>
        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <Text style={textStyle}>Trazabilidad de la muestra:</Text>
              <Text style={longTextStyle}> Hemos desarrollado un método eficaz para la identificación y seguimiento de la muestra dentro de nuestro laboratorio que nos permite conocer la identidad de la muestra de forma inequívoca desde el ingreso hasta el final del proceso. Para ellos se incluyen 6 STR (microsatélites) con un alto poder de discriminación al panel de amplicones del estudio genético a realizar.</Text>
            </View>
          </View>
        </View>

        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <Text style={textStyle}>Comentarios:</Text>
              <Text style={longTextStyle}> -Es altamente recomendado que la interpretación de este informe se realice con el asesoramiento de un médico familiarizado con el fenotipo del paciente y las causas genéticas que lo producen. Los resultados de este estudio son complementarios y deben ser interpretados en el contexto clínico de cada paciente.</Text>
              <Text style={longTextStyle}> -La ausencia de variantes patogénicas en los genes estudiados no descarta la predisposición genética a la enfermedad. Tampoco excluye la presencia de variantes patogénicas en otros genes potencialmente asociadas con esta patología.</Text>
              <Text style={longTextStyle}>-Nuestro laboratorio participa periódicamente de los ensayos intercomparativos (EQA Schemes) del "European Molecular Genetics Quality Network (EMQN, UK).</Text>
            </View>
          </View>
        </View>

        <View style={[mainContainerStyle, { marginTop: 8 }]}>
          <View style={[dataContainerStyle]}>
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <Text style={textStyle}>Bibliografía y/o bases de datos consultadas:</Text>
              <Text style={longTextStyle}> http://www.omim.org/</Text>
              <Text style={longTextStyle}> http://www.ncbi.nlm.nih.gov/clinvar/</Text>
              <Text style={longTextStyle}>http://www.lovd.nl/3.0/home</Text>
              <Text style={longTextStyle}>http://research.nhgri.nih.gov/bic</Text>
            </View>
          </View>
        </View>

        <View style={[mainContainerStyle]} break>
          <Text style={longTextStyle}>  ANEXO: Variantes benignas y probablemente benignas. </Text>
          <View style={[dataContainerStyle]}>
            <Table data={[
              { campo0: '13', campo1: "32890572", campo2: "Región 5 ́UTR", campo3: "BRCA2", campo4: "c.-26G>A", campo5: "-", campo6: "", campo7: "Benigna", campo8: "Heterocigota"  },
              { campo0: '13', campo1: "32906729", campo2: "Exónica", campo3: "BRCA2", campo4: "c.1114A>C", campo5: "p.(Asn372His)", campo6: "Cambio de sentido", campo7: "Benigna", campo8: "Heterocigota"  },
              { campo0: '13', campo1: "3291188829", campo2: "Exónica", campo3: "BRCA2", campo4: "c.3396A>G", campo5: "p.(Lys1132Lys)", campo6: "Sinónima", campo7: "Benigna", campo8: "Heterocigota"  },
              { campo0: '13', campo1: "32929232", campo2: "Exónica", campo3: "BRCA2", campo4: "c.7242A>G", campo5: "p.(Ser2414Ser)", campo6: "Sinónima", campo7: "Benigna", campo8: "Heterocigota"  },
              { campo0: '17', campo1: "41223094", campo2: "Exónica", campo3: "BRCA2", campo4: "c.4837A>G", campo5: "p.(Ser1613Gly)", campo6: "Cambio de sentido", campo7: "Benigna", campo8: "Heterocigota"  },
              { campo0: '17', campo1: "41234470", campo2: "Exónica", campo3: "BRCA2", campo4: "c.4308T>C", campo5: "p.(Ser1436Ser)", campo6: "Sinónima", campo7: "Benigna", campo8: "Heterocigota"  },
              { campo0: '17', campo1: "41244000", campo2: "Exónica", campo3: "BRCA2", campo4: "c.3548A>G", campo5: "p.(Lys1183Arg)", campo6: "Cambio de sentido", campo7: "Benigna", campo8: "Heterocigota"  },
              { campo0: '17', campo1: "41244435", campo2: "Exónica", campo3: "BRCA2", campo4: "c.3113A>G", campo5: "p.(Glu1038Gly)", campo6: "Cambio de sentido", campo7: "Benigna", campo8: "Heterocigota"  },
              { campo0: '17', campo1: "41244936", campo2: "Exónica", campo3: "BRCA2", campo4: "c.2612C>T", campo5: "p.(Pro871Leu)", campo6: "Cambio de sentido", campo7: "Benigna", campo8: "Heterocigota"  },
              { campo0: '17', campo1: "41245237", campo2: "Exónica", campo3: "BRCA2", campo4: "c.2311T>C", campo5: "p.(Leu771Leu)", campo6: "Sinónima", campo7: "Benigna", campo8: "Heterocigota"  },
              { campo0: '17', campo1: "41245466", campo2: "Exónica", campo3: "BRCA2", campo4: "c.2082C>T", campo5: "p.(Ser694Ser)", campo6: "Sinónima", campo7: "Benigna", campo8: "Heterocigota"  },
            ]}>
              <TableHeader textAlign={"center"} fontSize={FONT_SIZE}>
                <TableCell style={{ fontWeight: '800' }}> Cromosoma </TableCell>
                <TableCell style={{ fontWeight: '800' }}> Posicion genómica </TableCell>
                <TableCell style={{ fontWeight: '800' }}>Región </TableCell>
                <TableCell style={{ fontWeight: '800' }}> Gen</TableCell>
                <TableCell style={{ fontWeight: '800' }}> Variante en el Transcripto </TableCell>
                <TableCell style={{ fontWeight: '800' }}> Variante en la proteína </TableCell>
                <TableCell style={{ fontWeight: '800' }}> Efecto </TableCell>
                <TableCell style={{ fontWeight: '800' }}> Clasificación </TableCell>
                <TableCell style={{ fontWeight: '800' }}> Zigosis </TableCell>
              </TableHeader>
              <TableBody textAlign={"center"} fontSize={FONT_SIZE}>
                <DataTableCell style={{padding: 4}} getContent={(r) => r.campo0} />
                <DataTableCell style={{padding: 4}} getContent={(r) => r.campo1} />
                <DataTableCell style={{padding: 4}} getContent={(r) => r.campo2} />
                <DataTableCell style={{padding: 4}} getContent={(r) => r.campo3} />
                <DataTableCell style={{padding: 4}} getContent={(r) => r.campo4} />
                <DataTableCell style={{padding: 4}} getContent={(r) => r.campo5} />
                <DataTableCell style={{padding: 4}} getContent={(r) => r.campo6} />
                <DataTableCell style={{padding: 4}} getContent={(r) => r.campo7} />
                <DataTableCell style={{padding: 4}} getContent={(r) => r.campo8} />
              </TableBody>
            </Table>
          </View>
        </View>

        <FirmaEspecialista
          nombreEspecialista="amiloidosis"
          styleFromParent={{ marginTop: 20 }}
          isSigned={estudio.isSigned}
        />

        <View style={[dataContainerStyle, { marginTop: 20 }]}>
          <FirmaEspecialista
            nombreEspecialista="natalia"
            styleFromParent={{ flexDirection: 'column', flex: 1 }}
            isSigned={estudio.isSigned}
          />
          <FirmaEspecialista
            nombreEspecialista="sebastian"
            styleFromParent={{ flexDirection: 'column', flex: 1 }}
            isSigned={estudio.isSigned}
          />
        </View>
        <Footer CS />
      </Page>
  )

}



export default ReportBRNM;